import { keepPreviousData } from "@tanstack/react-query";

import { queryKeys } from "#shared/queryKeys/queryKeys";

import { fetchQuoteRequestLines, SearchData, SortData } from "./fetchQuoteRequestLines.api";

export const quoteRequestLinesQuery = (page = 1, search?: SearchData, sort?: SortData) => ({
  queryKey: queryKeys.quoteRequestLines.search(page, search, sort),
  queryFn: () => fetchQuoteRequestLines(page, search, sort),
  placeholderData: keepPreviousData,
  staleTime: 0,
});
